import type { ReactNode } from 'react'
import { Card, Avatar } from '../ui'
import { useTheme } from '../../hooks/useTheme'

export interface UserRelationCardProps {
  displayName: string
  username?: string
  photoUrl?: string
  fallbackBg: string
  badges: ReactNode
  onClick: () => void
}

export function UserRelationCard({
  displayName,
  username,
  photoUrl,
  fallbackBg,
  badges,
  onClick,
}: UserRelationCardProps) {
  const theme = useTheme()

  return (
    <Card variant="brand" showArrow onClick={onClick}>
      <div className="flex items-center gap-3 pr-6">
        <Avatar
          photoUrl={photoUrl}
          name={displayName}
          size="md"
          fallbackBg={fallbackBg}
        />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold truncate" style={{ color: theme.text.primary }}>
            {displayName}
          </p>
          {username && (
            <p className="text-xs truncate mt-0.5" style={{ color: theme.text.muted }}>
              @{username}
            </p>
          )}
          <div className="flex flex-wrap gap-1.5 mt-1.5">
            {badges}
          </div>
        </div>
      </div>
    </Card>
  )
}
